import axios from 'axios';
import { getToken } from './cookie';

export const PROD_API_BASE_URL =
  'https://pafdigitalsystem.pehlayakshar.org/PAF/';

const resolveBaseApiUrl = () => {
  const envUrl = (process.env.REACT_APP_BASE_API_URL || '').trim();

  if (envUrl.startsWith('https://') || envUrl.startsWith('http://')) {
    return envUrl.endsWith('/') ? envUrl : `${envUrl}/`;
  }

  return PROD_API_BASE_URL;
};

export const API_BASE_URL = resolveBaseApiUrl();

const attachAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(config => {
    const existingAuth =
      config.headers?.Authorization || config.headers?.get?.('Authorization');

    if (!existingAuth) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });
};

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'public, max-age=31536000, immutable'
  }
});

export const apiNoAuth = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'public, max-age=31536000, immutable'
  }
});

export const multipartApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json'
  }
});

attachAuthInterceptor(api);
attachAuthInterceptor(multipartApi);
